<template>
  <div class="vitiligoBasicInfoDialog" @contextmenu.prevent="">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogStatus"
      class="dialog"
      width="1280px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeVitiligoDialog"
    > 
      <div class="navBorder"></div>
      <div class="main" :style="{ maxHeight: contentMaxHeight }">
        <div class="left">
          <el-col :span="8">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">ID**</p>
              <el-input
                class="popInput"
                v-model="toDialoPatientsData.id_in_hospital"
                :disabled="true"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">姓名**</p>
              <el-input
                class="popInput"
                v-model="toDialoPatientsData.name"
                :disabled="true"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </el-col>

          <div v-for="(sectionData, section) in formData" :key="section" style="width:100%">
            <el-col :span="24" :offset="0">
              <div class="popTitleDialog" style="width:100%; text-align:left; color:#4da3c0; margin-top:12px;"> {{ section }} </div>
              <div class="navBorder"></div>
            </el-col>
            
            <div v-for="(field,index) in sectionData" :key="field.name" class="form-field">
              <el-col :span="6">
                <div class="leftItem">
                  <p class="rightItemTitle popTitleDialog">{{ field.label }}
                    <!-- <el-badge is-dot type="success" v-if="vitiligoData[field.name]"></el-badge> -->
                  </p>
                  <el-input
                    v-if="field.type === 'input'"
                    type="text"
                    class="popInput"
                    v-model="vitiligoData[field.name]"
                    :placeholder="field.placeholder"
                  ></el-input>

                  <el-input
                    v-else-if="field.type === 'number'"
                    type="number"
                    class="popInput"
                    v-model="vitiligoData[field.name]"
                    :placeholder="field.placeholder"
                  ></el-input>

                  <el-input
                    v-else-if="field.type === 'date'"
                    type="date"
                    class="popInput"
                    v-model="vitiligoData[field.name]"
                    :placeholder="field.placeholder"
                  ></el-input>
                  <!-- 下拉选择器 -->
                  <el-select   v-else-if="field.type === 'select'" 
                    :multiple="field.multiple"
                    placeholder="请选择" 
                    v-model="vitiligoData[field.name]" 
                    class="popInput"
                  >
                    <el-option
                      v-for="option in sectionData[index].option"
                      :key="option.id"
                      :label="option.label"
                      :value="option.value"
                    > </el-option>
                  </el-select>

                </div>
              </el-col>
            </div>
          </div>


          <!-- <el-col :span="24" :offset="8">
            <button
              class="btn iconfont leftItemSubmit"
              @click="submitVitiligo"
              style="padding: 0"
            >{{submitText}}</button>
          </el-col> -->



        </div>
      </div>

      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <button
          class="btn iconfont leftItemSubmit"
          @click="submitVitiligo"
          style="padding: 0"
        >{{submitText}}</button>
      </div>

    </el-dialog>
    <!-- <el-dialog
      class="dialog-pic"
      :visible.sync="showLargeImage1"
      center
      custom-class="similarDialog showBigImage_dialog_1"
      modal
      top="0"
      :fullscreen="true"
      @close="closePic"
    >
      <div class="bigImage">
        <Lookimage :largeImgage="largeImage"></Lookimage>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import moment from "moment";
import _ from "lodash";
import api from "../api";
import addVitiligoBasicInfo from "../gql/addVitiligoBasicInfo.gql";
import getVitiligoById from "../gql/getVitiligoById.gql";
import setVitiligoBasicInfo from "../gql/setVitiligoBasicInfo.gql";
import Jimp from 'jimp';
import gql from 'graphql-tag';
import axios from 'axios';
import Lookimage from './LookBigImage.vue';
let template = {};
export default {
  name: 'vitiligoBasicInfoDialog',
  data() {
    return {
      // 缩略图地址
      // hospitalization_imagesThumbnails: api.hospitalization_imagesThumbnails,
      // 大图地址
      // hospitalization_images: api.hospitalization_images,
      knowledgeDic: {},
      formLabelAlign: {},
      id: "146545643443",
      BWIndex: 1,
      // 用于生成界面表单，分为4个部分，每个部分包含若干个表单项，分别是 基本信息、皮损情况、病因病机、治疗情况，数据太长，在created 中 赋值
      formData: {},
      
      vitiligoData: {
        patient_id: "",
        visit_date: "",
        height: "",
        weight: "",
        onset_age: 0,
        duration_months: "",
        symmetry: "",
        vitiligo_type: "",
        first_location: "",
        current_location: "",
        mucosal_involvement: "",
        leukotrichia: "",
        bsa_score: "",
        progression_status: "",
        remark1: "",
        remark2: "",
        remark3: "",
        lesion_color: "",
        distribution_pattern: "",
        stability_features: "",
        boundary: "",
        symptoms: "",
        wood_lamp_color: "",
        wood_lamp_area: "",
        onset_season: "",
        onset_trigger: "",
        aggravation_trigger: "",
        recurrence_trigger: "",
        comorbidities: "",
        family_history: "",
        family_history_notes: "",
        autoimmune_family_history: "",
        autoimmune_family_notes: "",
        covid_vaccination: "",
        covid_infection: "",
        treatment_history: "",
        systemic_medication: "",
        topical_medication: "",
        phototherapy_method: "",
        phototherapy_type: "",
        surgical_treatment: "",
        other_treatments: "",
        update_time: ""
      },
      numberFields: ['height', 'weight', 'onset_age', 'duration_months', 'bsa_score'],
      dateFields: ['visit_date','update_time'],

      diagnosisId: '',
      inputOptions: {}, // 各个输入项的可选项（created 函数中初始化）
      keywordMap: {}, // 各个输入项关键词映射（created 函数中初始化）

      curativeEffectOptions: [
        { label: "痊愈", id: 0, value: "痊愈" },
        { label: "好转", id: 1, value: "好转" },
        { label: "无效", id: 2, value: "无效" }
      ],
      treatMethodOptions: [
        { label: "中西医治疗", id: 0, value: "中西医治疗" },
        { label: "中医治疗", id: 1, value: "中医治疗" },
        { label: "西医治疗", id: 2, value: "西医治疗" }
      ],
      // 2025-01-03 added by steven.
      diseaseCourseOptions: [
        {value:"入院"}, 
        {value:"出院"}, 
        {value:"日常"}
      ],
      mainDoctorList: [],
      viceDoctorList: [],
      inpatDoctorList: [],
      diseaseCourseList: [],

      // inpatImgPath: "",
      // outpatImgPath: "",
      // imgHeader: api.doctor_header,
      submitText: "新增记录",
      allDisease: [],
      
      addVitiligoId: -1,
      // 是否刷新列表
      isRefreshHandler: false,
      // 历史诊断详情页是否刷新图片
      isRefreshHandler1: false,
      showLargeImage1: false,
      // 住院查看大图地址
      largeImage: '',
      // 诊断算则和blur触发控制开关
      isTrigger: false,
      // 将病程等信息动态添加到对话框Title
      // dialogTitle: "住院记录",
      textAreaMaxLen: 70,

    };
  },
  components: {
    Lookimage,
  },
  computed: {
    dialogStatus: {
      get() {
        if (this.isShowVitiligo) {
          this.mainDoctorList = [];
          this.viceDoctorList = [];
          this.inpatDoctorList = [];
          this.diseaseCourseList = [];
          this.getLocalList(this.mainDoctorList, "mainDoctorListtest");
          this.getLocalList(this.viceDoctorList, "viceDoctorListtest");
          this.getLocalList(this.inpatDoctorList, "inpatDoctorListtest");
          this.getLocalList(this.diseaseCourseList, "diseaseCourseListtest");
          this.resetData();
        }
        console.log("dialogStatus", this.isShowVitiligo);
        return this.isShowVitiligo;
      },
      set(val) {
        this.$emit("setVitiligoStatus", val);
      }
    },
    dialogTitle(){
      let dialogTitle = "白癜风记录";
      // if(this.vitiligoData.disease_course){
      //   dialogTitle = dialogTitle + "--" + this.vitiligoData.disease_course;

      // }
      if(this.vitiligoData.visit_time){
        dialogTitle = dialogTitle + "--" + this.vitiligoData.visit_time;

      }
      return dialogTitle

    },
    // 根据视窗高度计算内容区域最大高度
    contentMaxHeight() {
      // 视窗高度的80%，减去对话框标题和底部的高度
      const maxHeight = window.innerHeight * 0.8 - 100
      return `${maxHeight}px`
    }
  },
  watch: {
    async 'lastDiagnosisText'(val) {
      try {
        const res = await this.$apollo.query({
          query: gql`{
          patient(id: ${val.id}){
              id
              last_diagnosis_text
            }
          }`,
          fetchPolicy: "no-cache",
        });
        const doctorConclusion = res.data.patient.last_diagnosis_text;
        // 查到最后一次的诊断结果
        if (doctorConclusion) {
          this.diagnosisId = doctorConclusion;
          this.vitiligoData.diagnosis = this.formatConclusion(doctorConclusion);
        }
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    async 'openVitiligoId'(newVal) {
      console.log("openVitiligoId watch:", newVal);
      if (newVal) {
        this.submitText = "修改记录";
        await this.getVitiligoById(Number(newVal));
        this.addVitiligoId = Number(newVal);
      } else {
        this.resetData();
        this.submitText = "新增记录";
      }
    },
    "vitiligoData.inpat_date"(newVal) {
      if (newVal) {
        this.$set(
          this.vitiligoData,
          "inpat_date",
          moment(newVal).format("YYYY-MM-DD")
        );
      }
    },
    "vitiligoData.outpat_date"(newVal) {
      if (newVal) {
        if (this.vitiligoData.inpat_date) {
          let contrast = !moment(newVal).isBefore(
            this.vitiligoData.inpat_date
          );
          if (contrast) {
            let days = moment(newVal).diff(
              moment(this.vitiligoData.inpat_date),
              "days"
            );
            this.$set(this.vitiligoData, "inpat_days_num", Number(days) + 1);
          } else {
            this.$alert("出院日期不能小于住院日期", "提示", {
              confirmButtonText: "确定"
            });
            this.$set(this.vitiligoData, "inpat_days_num", "");
            this.$set(this.vitiligoData, "outpat_date", "");
          }
        }
      } else {
        this.$set(this.vitiligoData, "inpat_days_num", "");
      }
    },
    "vitiligoData.inpat_days_num"(newVal) {
      if (newVal) {
        if (newVal <= 0) {
          this.$set(this.vitiligoData, "inpat_days_num", "");
        } else {
          if (this.vitiligoData.inpat_date) {
            let aa = moment(this.vitiligoData.inpat_date)
              .add(Number(newVal) - 1, "days")
              .format("YYYY-MM-DD");
            this.$set(this.vitiligoData, "outpat_date", aa);
          }
        }
      } else {
        this.$set(this.vitiligoData, "outpat_date", "");
      }
    }
  },
  props: {
    isShowVitiligo: {
      type: Boolean,
      default: () => false
    },
    toDialoPatientsData: {
      type: Object
    },
    openVitiligoId: {
      type: Number,
      default: () => null
    },
    lastDiagnosisText: Object,
  },
  methods: {
    closeVitiligoDialog() {
      if (this.isRefreshHandler) {
        this.$emit('refreshHandler',Number(this.toDialoPatientsData.id));
      }
      // if (this.isRefreshHandler1) {
      //   this.$emit('refreshHandler2', {
      //     id: this.addVitiligoId,
      //     images: this.allImagesList,
      //   });
      // }
      this.diagnosisId = '';
      this.addVitiligoId = -1;
      // this.inpatImagesList = [];
      // this.outpatImagesList = [];
      // this.allImagesList = [];
      this.isRefreshHandler = false;
      this.isRefreshHandler1 = false;
    },
    formatConclusion(id) {
      let name;
      // 从自定义模板中找病种名称
      const f = data => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === id) {
            name = data[i].name;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义中没有找到则在原始模板中查找
      if (!name) {
        if (this.knowledgeDic[id]) {
          name = this.knowledgeDic[id].name;
        }
      }
      return name ? name : id;
    },
    // 获取医生自定义模板
    async queryMyTemplate() {
      // 请求医生自定义的模板路径
      const res = await this.$apollo.query({
        query: gql`{
          me{
            id
            template
          }
        }`,
        fetchPolicy: 'no-cache',
      });
      // 根据路径请求模板
      const path = res.data.me.template;
      // 如果没有自定义模板
      if (path === '') {
        return;
      }
      const msg =  await axios.request({
        method: 'get',
        url: api.template + path,
      });
      template = msg.data;
    },
    async getKnowledgeDic() {
      // 获取报告模板病名与id文件
      try {
        const knowledgeDic = await axios.request({
          method: "get",
          url: api.knowledgeDic
        });
        this.knowledgeDic = knowledgeDic.data;
        // 生成影像诊断筛选数据
        const allDiseaseArr = [];
        for (let key in this.knowledgeDic) {
          if (this.knowledgeDic.hasOwnProperty(key)) {
            allDiseaseArr.push({
              value: this.knowledgeDic[key].name,
              id: key
            });
          }
        }
        this.allDisease = allDiseaseArr;
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    queryDisease(queryString, cb) {
      const restaurants = this.allDisease;
      const results = queryString ? restaurants.filter(this.filterDisease(queryString)) : restaurants;
      const arr = [];
      const f = (data) => {
        for (let i = 0; i < data.length; i++) {
          if (!data[i].children && data[i].id !== '1' && data[i].id !== '2' && data[i].id !== '3' && data[i].id !== '4' && data[i].id !== '5' && !data[i].subclass) {
            if (data[i].name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) {
              arr.push({
                id: data[i].id,
                value: data[i].name,
              })
            }
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      for (const item of results) {
        const findIndex = arr.findIndex(item1 => item.value === item1.value);
        if (findIndex === -1) {
          arr.push(item);
        }
      }
      cb(arr);
    },
    filterDisease(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
        );
      };
    },
    selectedDisease(item) {
      this.isTrigger = true;
      // this.selectedDiagnose = true;
      // this.vitiligoData.diagnosis = item.value;
      this.diagnosisId = item.id;
    },
    selectedDiseaseBlur(val) {
      setTimeout(() => {
        if (this.isTrigger) {
          this.isTrigger = false;
          return;
        }
        if (!val) {
          this.diagnosisId = '';
        } else {
          const findId = this.queryTemplatesByName(val);
          if (findId) {
            this.diagnosisId = findId;
          } else {
            this.diagnosisId = '';
          }
        }
      }, 300);
    },
    // 通过name查找影像诊断id
    queryTemplatesByName(name) {
      let id;
      // 在自定义模板中查找
      const f = (data) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].name === name) {
            id = data[i].id;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义模板中为找到就在原始模板中找
      for (const item of this.allDisease) {
        if (item.value === name) {
          id = item.id;
          break;
        }
      }
      return id;
    },
    resetData() {
      this.vitiligoData = {        
        patient_id: Number(this.toDialoPatientsData.id),
        visit_date: "",
        height: "",
        weight: "",
        onset_age: 0,
        duration_months: "",
        symmetry: "",
        vitiligo_type: "",
        first_location: "",
        current_location: "",
        mucosal_involvement: "",
        leukotrichia: "",
        bsa_score: "",
        progression_status: "",
        remark1: "",
        remark2: "",
        remark3: "",
        lesion_color: "",
        distribution_pattern: "",
        stability_features: "",
        boundary: "",
        symptoms: "",
        wood_lamp_color: "",
        wood_lamp_area: "",
        onset_season: "",
        onset_trigger: "",
        aggravation_trigger: "",
        recurrence_trigger: "",
        comorbidities: "",
        family_history: "",
        family_history_notes: "",
        autoimmune_family_history: "",
        autoimmune_family_notes: "",
        covid_vaccination: "",
        covid_infection: "",
        treatment_history: "",
        systemic_medication: "",
        topical_medication: "",
        phototherapy_method: "",
        phototherapy_type: "",
        surgical_treatment: "",
        other_treatments: "",
        update_time: ""
      };
    },
    async getVitiligoById(id) {
      try {
        let res = await this.$apollo.query({
          query: getVitiligoById,
          fetchPolicy: "no-cache",
          variables: {
            id
          }
        });
        let data = res.data.vitiligoBasicInfo;
        console.log("In getVitiligoById, data:", data);
        for(let key in this.vitiligoData){
          // console.log(key, this.numberFields.includes(key));
          if(this.numberFields.includes(key)){
            if(data[key]===-1 || data[key]===null){
              this.vitiligoData[key] = '';
            }else{
              this.vitiligoData[key] = Number(data[key]);
            }            
          }else if(this.dateFields.includes(key)){
            if(data[key]!== -30610253143000){
              this.vitiligoData[key] = moment(data[key]).format("YYYY-MM-DD");
            }else{
              this.vitiligoData[key] = "";
            }
          } else{
            this.vitiligoData[key] = this.transformStr2Array(key, data[key]);
          }         
        }
        console.log("In getVitiligoById, after handling, vitiligoData:", this.vitiligoData);
        // this.diagnosisId = data.id;

        // 显示图片数据
        // for (const item of data.image_hospitalization) {
        //   item.deletePic = false;
        //   item.menuLeft = '';
        //   item.menuTop = '';
        // }
        // this.inpatImagesList = data.image_hospitalization.filter(item => item.type === 1);
        // this.outpatImagesList = data.image_hospitalization.filter(item => item.type === 2);
        // this.allImagesList = data.image_hospitalization;
        // if (data.inpat_date !== -30610253143000) {
        //   this.vitiligoData.inpat_date = moment(data.inpat_date).format(
        //     "YYYY-MM-DD"
        //   );
        // } else {
        //   this.vitiligoData.inpat_date = "";
        // }
        // if (data.outpat_date !== -30610253143000) {
        //   this.vitiligoData.outpat_date = moment(data.outpat_date).format(
        //     "YYYY-MM-DD"
        //   );
        // } else {
        //   this.vitiligoData.outpat_date = "";
        // }
      } catch (error) {
        // console.log(error);
        this.$message.success("数据获取失败");
        this.$emit("setVitiligoStatus", false);
      }
    },
    // 判断该字段是否是 select-multiple。 如果是，则将字符串（逗号隔开多个选项）转化为序列用于在 界面显示；若否，直接返回原字符串
    transformStr2Array(key, inputStr){
      let matched = false;
      for(let sectionName in this.formData){
        for(let form of this.formData[sectionName]){
          if(form.name===key && form.multiple===true){
            matched = true
            break 
          }
        }
        if(matched){
          break
        }
      }
      if(matched){
        // 移除首尾空格（如果有需要）
        let str = inputStr.trim();
        // 移除末尾逗号（如果存在）
        if (str.endsWith(',')) {
          str = str.slice(0, -1);
        }
        if(str==''){
          return []
        }
        // 分割并过滤空值
        const newArray = str.split(',').filter(item => item !== '');
        return newArray
      }else{
        return inputStr
      }
      
    },

    transformArray2Str(key, array){
          let matched = false;
          for(let sectionName in this.formData){
            for(let form of this.formData[sectionName]){
              if(form.name===key && form.multiple===true){
                matched = true
                break 
              }
            }
            if(matched){
              break
            }
          }
          if(matched){
            return array.join(',') ;
          }else{
            return array;
          }
    },


    getLocalList(thisData, localName) {
      let DoctorList = localStorage.getItem(localName);
      if (DoctorList) {
        let data = JSON.parse(DoctorList);
        for (const item of data) {
          thisData.push({ value: item });
        }
      }
    },
    choiceBW(status) {
      this.BWIndex = status;
    },
    // 病程列表，预置 this.diseaseCourseList
    diseaseCourseSuggesion(suggesionString, cb) {
      // let results = this.diseaseCourseList;
      // 将默认的选项放到列表最前面
      let results = this.diseaseCourseOptions.concat(this.diseaseCourseList);
      // console.log("diseaseCourseSuggesion:",results);
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    mainSuggesion(mainSuggesionString, cb) {
      let results = this.mainDoctorList;
      // 调用 callback 返回建议列表的数据
      console.log("mainSuggesion:",results);
      cb(results);
    },
    viceSuggesion(viceSuggesionString, cb) {
      let results = this.viceDoctorList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    inpatSuggesion(inpatSuggesionString, cb) {
      let results = this.inpatDoctorList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    saveSuggesion(type) {
      if (type === 0) {
        this.saveLocalList(
          this.vitiligoData.main_diagnosis_doctor,
          "mainDoctorListtest"
        );
      } else if (type === 1) {
        this.saveLocalList(
          this.vitiligoData.vice_diagnosis_doctor,
          "viceDoctorListtest"
        );
      } else if (type === 2) {
        this.saveLocalList(
          this.vitiligoData.inpat_doctor,
          "inpatDoctorListtest"
        );
      }else if (type === 3) {
        let found = false;
        // 是否已经存在于预设选项
        for(let option of this.diseaseCourseOptions){
          if(this.vitiligoData.disease_course===option.value){
            found = true;
            break;
          }
        }
        if(!found){
          this.saveLocalList(
            this.vitiligoData.disease_course,
            "diseaseCourseListtest"
          );
        }
      } else {

      }
    },
    saveLocalList(thisData, localName) {
      if (thisData) {
        let mainDoctorList = localStorage.getItem(localName);
        if (mainDoctorList) {
          let data = JSON.parse(mainDoctorList);
          data.unshift(thisData);
          let NewData = _.chunk(_.uniq(data), 5)[0];
          localStorage.setItem(localName, JSON.stringify(NewData));
          // console.log("saveLocalList:",data);
        } else {
          let data = [];
          data.unshift(thisData);
          localStorage.setItem(localName, JSON.stringify(data));
          // console.log("saveLocalList:",data);
        }
        
      }
    },
    async submitVitiligo() {
      if (this.openVitiligoId) {
        await this.setVitiligo();
      } else {
        await this.addVitiligo();
      }
    },
    async addVitiligo() {
      if (this.addVitiligoId > -1) {
        this.$message.error("已经新增了白癜风信息");
        return
      }
      try {
        let obj = {};
        for(const key in this.vitiligoData){ 
          if(this.numberFields.includes(key)){
            if(this.vitiligoData[key]===''){
              obj[key] = -1;
            }else{
              obj[key] = Number(this.vitiligoData[key]);
            }
          }else if(this.dateFields.includes(key)){
            obj[key] = this.vitiligoData[key]
              ? this.vitiligoData[key]
              : "1000-01-01 00:00:00";
          } else{
            // 多选框处理，使用逗号分隔存储
            if(Array.isArray(this.vitiligoData[key])){
              obj[key] =  this.vitiligoData[key].join(',');
            }else{
              obj[key] = this.vitiligoData[key];
            }
          }
        }
        obj.patient_id = Number(this.toDialoPatientsData.id) 
        console.log("In addVitiligo, obj:",obj);

        const res = await this.$apollo.mutate({
          mutation: addVitiligoBasicInfo,
          variables: obj
        });
        this.addVitiligoId = res.data.addVitiligoBasicInfo.id;
        this.$message.success("数据已保存");
        this.isRefreshHandler = true;
        // this.$emit('setVitiligoStatus',false);
      } catch (error) {
        this.$message.error("保存失败");
      }
    },
    async setVitiligo() {
      try {
        let obj = {};
        for(const key in this.vitiligoData){ 
          if(this.numberFields.includes(key)){
            if(this.vitiligoData[key]==='' || this.vitiligoData[key]===null){
              obj[key] = -1;
            }else{
              obj[key] = Number(this.vitiligoData[key]);
            }
          }else if(this.dateFields.includes(key)){
            obj[key] = this.vitiligoData[key]
              ? this.vitiligoData[key]
              : "1000-01-01 00:00:00";
          } else{
            // 多选框处理，使用逗号分隔存储
            if(Array.isArray(this.vitiligoData[key])){
              obj[key] =  this.vitiligoData[key].join(',');
            }else{
              obj[key] = this.vitiligoData[key];
            }
          }
        }
        obj.id = this.openVitiligoId;
        obj.patient_id = Number(this.toDialoPatientsData.id) 
        console.log("In setVitiligo, obj:",obj);

        await this.$apollo.mutate({
          mutation: setVitiligoBasicInfo,
          variables: obj
          // {
          //   id: this.openVitiligoId,
          //   patient_id: Number(this.toDialoPatientsData.id),

          //   // inpat_date: this.vitiligoData.inpat_date
          //   //   ? this.vitiligoData.inpat_date
          //   //   : "1000-01-01 00:00:00",
            
          // }
        });
        this.$message.success("数据已保存");
        this.isRefreshHandler = true;
        this.$emit('refreshHandler1', {
          id: this.openVitiligoId          
        });
        this.$emit('setVitiligoStatus',false);
      } catch (error) {
        this.$message.error("保存失败");
      }
    },
    genInputOptions(){
      let options = {
        genderOptions: [ { label: "男", id: 0, value: "男" }, { label: "女", id: 1, value: "女" } ],
        symmetryOptions: [ { label: "不对称", id: 0, value: "不对称" }, { label: "对称", id: 1, value: "对称" } ],
        vitiligo_typeOptions: [ 
          { label: "", id: 0, value: "" },
          { label: "节段型", id: 1, value: "节段型" },
          { label: "非节段型", id: 2, value: "非节段型" },
          { label: "混合型", id: 3, value: "混合型" },
          { label: "未定类型", id: 4, value: "未定类型" }
        ],
        first_locationOptions: [ 
          { label: "", id: 0, value: "" },
          { label: "头皮", id: 1, value: "头皮" },
          { label: "额部", id: 2, value: "额部" },
          { label: "眶周", id: 3, value: "眶周" },
          { label: "眉周", id: 4, value: "眉周" },
          { label: "口周", id: 5, value: "口周" },
          { label: "耳缘", id: 6, value: "耳缘" },
          { label: "面部", id: 7, value: "面部" },
          { label: "颈部", id: 8, value: "颈部" },
          { label: "前胸", id: 9, value: "前胸" },
          { label: "后背", id: 10, value: "后背" },
          { label: "腹部", id: 11, value: "腹部" },
          { label: "腰部", id: 12, value: "腰部" },
          { label: "髂部", id: 13, value: "髂部" },
          { label: "腹股沟区", id: 14, value: "腹股沟区" },
          { label: "会阴区", id: 15, value: "会阴区" },
          { label: "臀部", id: 16, value: "臀部" },
          { label: "上肢", id: 17, value: "上肢" },
          { label: "前臂", id: 18, value: "前臂" },
          { label: "肘关节伸侧", id: 19, value: "肘关节伸侧" },
          { label: "股部", id: 20, value: "股部" },
          { label: "小腿", id: 21, value: "小腿" },
          { label: "膝关节伸侧", id: 22, value: "膝关节伸侧" },
          { label: "手背", id: 23, value: "手背" },
          { label: "手掌", id: 24, value: "手掌" },
          { label: "掌指关节伸侧", id: 25, value: "掌指关节伸侧" },
          { label: "足背", id: 26, value: "足背" },
          { label: "足底", id: 27, value: "足底" },
          { label: "足跖关节伸侧", id: 28, value: "足跖关节伸侧" },
          { label: "乳晕", id: 29, value: "乳晕" },
          { label: "生殖器", id: 30, value: "生殖器" },
          { label: "腋下", id: 31, value: "腋下" },
          { label: "鼻周", id: 32, value: "鼻周" },
          { label: "肛周", id: 33, value: "肛周" },
          { label: "手腕", id: 34, value: "手腕" },
          { label: "腘窝", id: 35, value: "腘窝" }
        ],
        current_locationOptions: [ 
          { label: "", id: 0, value: "" },
          { label: "头皮", id: 1, value: "头皮" },
          { label: "额部", id: 2, value: "额部" },
          { label: "眶周", id: 3, value: "眶周" },
          { label: "眉周", id: 4, value: "眉周" },
          { label: "口周", id: 5, value: "口周" },
          { label: "耳缘", id: 6, value: "耳缘" },
          { label: "面部", id: 7, value: "面部" },
          { label: "颈部", id: 8, value: "颈部" },
          { label: "前胸", id: 9, value: "前胸" },
          { label: "后背", id: 10, value: "后背" },
          { label: "腹部", id: 11, value: "腹部" },
          { label: "腰部", id: 12, value: "腰部" },
          { label: "髂部", id: 13, value: "髂部" },
          { label: "腹股沟区", id: 14, value: "腹股沟区" },
          { label: "会阴区", id: 15, value: "会阴区" },
          { label: "臀部", id: 16, value: "臀部" },
          { label: "上肢", id: 17, value: "上肢" },
          { label: "前臂", id: 18, value: "前臂" },
          { label: "肘关节伸侧", id: 19, value: "肘关节伸侧" },
          { label: "股部", id: 20, value: "股部" },
          { label: "小腿", id: 21, value: "小腿" },
          { label: "膝关节伸侧", id: 22, value: "膝关节伸侧" },
          { label: "手背", id: 23, value: "手背" },
          { label: "手掌", id: 24, value: "手掌" },
          { label: "掌指关节伸侧", id: 25, value: "掌指关节伸侧" },
          { label: "足背", id: 26, value: "足背" },
          { label: "足底", id: 27, value: "足底" },
          { label: "足跖关节伸侧", id: 28, value: "足跖关节伸侧" },
          { label: "乳晕", id: 29, value: "乳晕" },
          { label: "生殖器", id: 30, value: "生殖器" },
          { label: "腋下", id: 31, value: "腋下" },
          { label: "鼻周", id: 32, value: "鼻周" },
          { label: "肛周", id: 33, value: "肛周" },
          { label: "手腕", id: 34, value: "手腕" },
          { label: "腘窝", id: 35, value: "腘窝" }
        ],

        mucosal_involvementOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "口唇", id: 1, value: "口唇" },
          { label: "乳晕", id: 2, value: "乳晕" },
          { label: "生殖器", id: 3, value: "生殖器" }
        ],

        leukotrichiaOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "头发变白", id: 1, value: "头发变白" },
          { label: "眉毛变白", id: 2, value: "眉毛变白" },
          { label: "睫毛变白", id: 3, value: "睫毛变白" },
          { label: "胡须变白", id: 4, value: "胡须变白" },
          { label: "腋毛变白", id: 5, value: "腋毛变白" },
          { label: "阴毛变白", id: 6, value: "阴毛变白" },
          { label: "汗毛变白", id: 7, value: "汗毛变白" },
          { label: "鼻毛变白", id: 8, value: "鼻毛变白" }
        ],

        progression_statusOptions: [ 
          { label: "白斑有复色", id: 0, value: "白斑有复色" },
          { label: "白斑近1年稳定", id: 1, value: "白斑近1年稳定" },
          { label: "白斑近1年进展", id: 2, value: "白斑近1年进展" },
          { label: "白斑近6月进展", id: 3, value: "白斑近6月进展" },
          { label: "白斑近3月进展", id: 4, value: "白斑近3月进展" },
          { label: "白斑近6周进展", id: 5, value: "白斑近6周进展" }
        ],

        remark1Options: [ { label: "", id: 0, value: "" } ],

        remark2Options: [ { label: "", id: 0, value: "" } ],

        remark3Options: [ { label: "", id: 0, value: "" } ],

        lesion_colorOptions: [ 
          { label: "", id: 0, value: "" },
          { label: "瓷白色", id: 1, value: "瓷白色" },
          { label: "乳白色", id: 2, value: "乳白色" },
          { label: "灰白色", id: 3, value: "灰白色" },
          { label: "其他", id: 4, value: "其他" }
        ],

        distribution_patternOptions: [ 
          { label: "", id: 0, value: "" },
          { label: "多发性点状白斑", id: 1, value: "多发性点状白斑" },
          { label: "椭圆形白斑", id: 2, value: "椭圆形白斑" },
          { label: "两者都有", id: 3, value: "两者都有" },
          { label: "其他", id: 4, value: "其他" }
        ],

        stability_featuresOptions: [ 
          { label: "白斑区复色", id: 0, value: "白斑区复色" },
          { label: "白斑边界清楚", id: 1, value: "白斑边界清楚" },
          { label: "白斑边界模糊", id: 2, value: "白斑边界模糊" },
          { label: "碎纸屑样白斑", id: 3, value: "碎纸屑样白斑" },
          { label: "三色征", id: 4, value: "三色征" }
        ],

        boundaryOptions: [ 
          { label: "", id: 0, value: "" },
          { label: "部分边界清楚", id: 1, value: "部分边界清楚" },
          { label: "部分边界模糊", id: 2, value: "部分边界模糊" }
        ],

        symptomsOptions: [ 
          { label: "无症状", id: 0, value: "无症状" },
          { label: "瘙痒", id: 1, value: "瘙痒" },
          { label: "灼热", id: 2, value: "灼热" },
          { label: "白斑周围发红", id: 3, value: "白斑周围发红" },
          { label: "晕痣", id: 4, value: "晕痣" },
          { label: "有同形反应", id: 5, value: "有同形反应" },
          { label: "其他", id: 6, value: "其他" }
        ],

        wood_lamp_colorOptions: [ 
          { label: "", id: 0, value: "" },
          { label: "亮蓝色", id: 1, value: "亮蓝色" },
          { label: "蓝白色", id: 2, value: "蓝白色" },
          { label: "深棕色和黑色", id: 3, value: "深棕色和黑色" },
          { label: "其他", id: 4, value: "其他" }
        ],

        wood_lamp_areaOptions: [ 
          { label: "无法准确评估", id: 0, value: "无法准确评估" },
          { label: "大于肉眼白斑", id: 1, value: "大于肉眼白斑" },
          { label: "等于肉眼白斑", id: 2, value: "等于肉眼白斑" },
          { label: "小于肉眼白斑", id: 3, value: "小于肉眼白斑" }
        ],

        onset_seasonOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "春天", id: 1, value: "春天" },
          { label: "夏天", id: 2, value: "夏天" },
          { label: "秋天", id: 3, value: "秋天" },
          { label: "冬天", id: 4, value: "冬天" }
        ],

        onset_triggerOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "农药", id: 1, value: "农药" },
          { label: "化工产品", id: 2, value: "化工产品" },
          { label: "冻伤", id: 3, value: "冻伤" },
          { label: "烫伤", id: 4, value: "烫伤" },
          { label: "外伤", id: 5, value: "外伤" },
          { label: "劳累", id: 6, value: "劳累" },
          { label: "焦虑", id: 7, value: "焦虑" },
          { label: "压力大", id: 8, value: "压力大" },
          { label: "悲伤", id: 9, value: "悲伤" },
          { label: "日光暴晒", id: 10, value: "日光暴晒" },
          { label: "疫苗接种", id: 11, value: "疫苗接种" },
          { label: "特殊药物", id: 12, value: "特殊药物" },
          { label: "妊娠", id: 13, value: "妊娠" },
          { label: "产后", id: 14, value: "产后" },
          { label: "感染新冠", id: 15, value: "感染新冠" },
          { label: "感染乙肝", id: 16, value: "感染乙肝" },
          { label: "感染丙肝", id: 17, value: "感染丙肝" },
          { label: "感染艾滋", id: 18, value: "感染艾滋" },
          { label: "流感", id: 19, value: "流感" }
        ],

        aggravation_triggerOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "农药", id: 1, value: "农药" },
          { label: "化工产品", id: 2, value: "化工产品" },
          { label: "冻伤", id: 3, value: "冻伤" },
          { label: "烫伤", id: 4, value: "烫伤" },
          { label: "外伤", id: 5, value: "外伤" },
          { label: "劳累", id: 6, value: "劳累" },
          { label: "焦虑", id: 7, value: "焦虑" },
          { label: "压力大", id: 8, value: "压力大" },
          { label: "悲伤", id: 9, value: "悲伤" },
          { label: "日光暴晒", id: 10, value: "日光暴晒" },
          { label: "疫苗接种", id: 11, value: "疫苗接种" },
          { label: "特殊药物", id: 12, value: "特殊药物" },
          { label: "妊娠", id: 13, value: "妊娠" },
          { label: "产后", id: 14, value: "产后" },
          { label: "感染新冠", id: 15, value: "感染新冠" },
          { label: "感染乙肝", id: 16, value: "感染乙肝" },
          { label: "感染丙肝", id: 17, value: "感染丙肝" },
          { label: "感染艾滋", id: 18, value: "感染艾滋" },
          { label: "流感", id: 19, value: "流感" }
        ],

        recurrence_triggerOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "农药", id: 1, value: "农药" },
          { label: "化工产品", id: 2, value: "化工产品" },
          { label: "冻伤", id: 3, value: "冻伤" },
          { label: "烫伤", id: 4, value: "烫伤" },
          { label: "外伤", id: 5, value: "外伤" },
          { label: "劳累", id: 6, value: "劳累" },
          { label: "焦虑", id: 7, value: "焦虑" },
          { label: "压力大", id: 8, value: "压力大" },
          { label: "悲伤", id: 9, value: "悲伤" },
          { label: "日光暴晒", id: 10, value: "日光暴晒" },
          { label: "疫苗接种", id: 11, value: "疫苗接种" },
          { label: "特殊药物", id: 12, value: "特殊药物" },
          { label: "妊娠", id: 13, value: "妊娠" },
          { label: "产后", id: 14, value: "产后" },
          { label: "感染新冠", id: 15, value: "感染新冠" },
          { label: "感染乙肝", id: 16, value: "感染乙肝" },
          { label: "感染丙肝", id: 17, value: "感染丙肝" },
          { label: "感染艾滋", id: 18, value: "感染艾滋" },
          { label: "流感", id: 19, value: "流感" }
        ],

        comorbiditiesOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "斑秃", id: 1, value: "斑秃" },
          { label: "特应性皮炎", id: 2, value: "特应性皮炎" },
          { label: "银屑病", id: 3, value: "银屑病" },
          { label: "红斑狼疮", id: 4, value: "红斑狼疮" },
          { label: "甲亢", id: 5, value: "甲亢" },
          { label: "甲减", id: 6, value: "甲减" },
          { label: "桥本氏甲状腺炎", id: 7, value: "桥本氏甲状腺炎" },
          { label: "甲功异常", id: 8, value: "甲功异常" },
          { label: "1型糖尿病", id: 9, value: "1型糖尿病" },
          { label: "2型糖尿病", id: 10, value: "2型糖尿病" },
          { label: "乙肝", id: 11, value: "乙肝" },
          { label: "丙肝", id: 12, value: "丙肝" },
          { label: "艾滋病", id: 13, value: "艾滋病" },
          { label: "炎症性肠病", id: 14, value: "炎症性肠病" },
          { label: "类风湿性关节炎", id: 15, value: "类风湿性关节炎" },
          { label: "强直性脊柱炎", id: 16, value: "强直性脊柱炎" },
          { label: "其他", id: 17, value: "其他" }
        ],

        family_historyOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "家族中1人", id: 1, value: "家族中1人" },
          { label: "家族中2人", id: 2, value: "家族中2人" },
          { label: "家族中3人", id: 3, value: "家族中3人" },
          { label: "家族中3人以上", id: 4, value: "家族中3人以上" }
        ],

        family_history_notesOptions: [ { label: "", id: 0, value: "" } ],

        autoimmune_family_historyOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "有", id: 1, value: "有" }
        ],

        autoimmune_family_notesOptions: [ { label: "", id: 0, value: "" } ],

        covid_vaccinationOptions: [ 
          { label: "未接种", id: 0, value: "未接种" },
          { label: "已接种", id: 1, value: "已接种" }
        ],

        covid_infectionOptions: [ 
          { label: "未感染", id: 0, value: "未感染" },
          { label: "已感染,", id: 1, value: "已感染," }
        ],

        treatment_historyOptions: [ 
          { label: "未治疗", id: 0, value: "未治疗" },
          { label: "已治疗", id: 1, value: "已治疗" }
        ],

        systemic_medicationOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "托法替布", id: 1, value: "托法替布" },
          { label: "巴瑞替尼", id: 2, value: "巴瑞替尼" },
          { label: "得宝松肌注", id: 3, value: "得宝松肌注" },
          { label: "甲泼尼龙片", id: 4, value: "甲泼尼龙片" },
          { label: "泼尼松片", id: 5, value: "泼尼松片" },
          { label: "复方甘草酸苷片", id: 6, value: "复方甘草酸苷片" },
          { label: "环孢素", id: 7, value: "环孢素" },
          { label: "甲氨蝶呤", id: 8, value: "甲氨蝶呤" },
          { label: "中药", id: 9, value: "中药" },
          { label: "胸腺肽", id: 10, value: "胸腺肽" },
          { label: "补钙", id: 11, value: "补钙" },
          { label: "白芍总苷", id: 12, value: "白芍总苷" },
          { label: "白灵片", id: 13, value: "白灵片" },
          { label: "乌帕替尼", id: 14, value: "乌帕替尼" },
          { label: "阿布昔替尼", id: 15, value: "阿布昔替尼" },
          { label: "利特昔替尼", id: 16, value: "利特昔替尼" },
          { label: "他克莫司（口服）", id: 17, value: "他克莫司（口服）" }
        ],

        topical_medicationOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "卤米松/丙酸氟替卡松", id: 1, value: "卤米松/丙酸氟替卡松" },
          { label: "他克莫司", id: 2, value: "他克莫司" },
          { label: "复方卡力孜然酊", id: 3, value: "复方卡力孜然酊" },
          { label: "克立硼罗软膏", id: 4, value: "克立硼罗软膏" },
          { label: "芦可替尼乳膏", id: 5, value: "芦可替尼乳膏" }
        ],

        phototherapy_methodOptions: [ 
          { label: "未做", id: 0, value: "未做" },
          { label: "家庭", id: 1, value: "家庭" },
          { label: "医院", id: 2, value: "医院" },
          { label: "不详", id: 3, value: "不详" }
        ],

        phototherapy_typeOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "NB-UVB", id: 1, value: "NB-UVB" },
          { label: "308nm准分子光（希兰）", id: 2, value: "308nm准分子光（希兰）" },
          { label: "308nm准分子激光", id: 3, value: "308nm准分子激光" },
          { label: "308nmLED", id: 4, value: "308nmLED" },
          { label: "激光+得宝松导入", id: 5, value: "激光+得宝松导入" },
          { label: "激光+5-Fu导入", id: 6, value: "激光+5-Fu导入" },
          { label: "308nm光疗", id: 7, value: "308nm光疗" }
        ],

        surgical_treatmentOptions: [ 
          { label: "未做", id: 0, value: "未做" },
          { label: "表皮负压吸疱移植", id: 1, value: "表皮负压吸疱移植" },
          { label: "毛囊移植", id: 2, value: "毛囊移植" },
          { label: "晕痣切除", id: 3, value: "晕痣切除" }
        ],

        other_treatmentsOptions: [ 
          { label: "无", id: 0, value: "无" },
          { label: "火针", id: 1, value: "火针" },
          { label: "RPR治疗", id: 2, value: "RPR治疗" },
          { label: "白癜风洗剂", id: 3, value: "白癜风洗剂" }
        ]
      };
      return options;
    },

    genKeywordMap(){
      let vitiligoFieldMap = {
        visit_date: "接诊时间",
        name: "姓名",
        id_in_hospital: "ID号",
        age_at_visit: "就诊年龄（岁）",
        height: "身高（cm）",
        weight: "体重（kg）",
        onset_age: "白斑首发年龄（岁）",
        duration_months: "白斑病程（月）",
        symmetry: "白斑对称性",
        vitiligo_type: "白癜风分型",
        first_location: "白斑首次出现部位",
        current_location: "现白斑部位",
        mucosal_involvement: "粘膜受累(阴囊不计入黏膜）",
        leukotrichia: "白毛白发",
        bsa_score: "BSA评分（％）",
        progression_status: "白斑进展情况",
        remark1: "备注1",
        remark2: "备注2",
        remark3: "备注3",
        lesion_color: "白斑颜色",
        distribution_pattern: "白斑分布特征",
        stability_features: "白斑稳定/活动特征",
        boundary: "备注-边界",
        symptoms: "白斑症状及其他伴随现象",
        wood_lamp_color: "wood灯下白斑颜色",
        wood_lamp_area: "wood灯下白斑面积",
        onset_season: "白斑发病季节",
        onset_trigger: "白斑发病诱因",
        aggravation_trigger: "白斑加重诱因",
        recurrence_trigger: "白斑复发诱因",
        comorbidities: "伴发疾病",
        family_history: "白癜风家族史",
        family_history_notes: "阳性家族史备注-亲属关系",
        autoimmune_family_history: "自身免疫性疾病家族史",
        autoimmune_family_notes: "阳性自免病家族史备注-疾病和关系",
        covid_vaccination: "新冠疫苗接种史",
        covid_infection: "新冠疫苗感染史",
        treatment_history: "白癜风治疗",
        systemic_medication: "白癜风系统用药",
        topical_medication: "白癜风用药2",
        phototherapy_method: "光疗方式",
        phototherapy_type: "光疗类型",
        surgical_treatment: "外科手术",
        other_treatments: "其他治疗"
      };
      return vitiligoFieldMap;
    },
    // 生成用于生成UI 表单的数据
    genForms(){
      let formData= {
        基本信息: [
          // {
          //   "label": "ID号",
          //   "name": "id_in_hospital",
          //   "type": "input",
          //   "placeholder": "请输入ID号"
          // },
          {
            "label": "接诊时间",
            "name": "visit_date",
            "type": "date",
            "placeholder": "请选择接诊时间"
          },
          {
            "label": "就诊年龄（岁）",
            "name": "age_at_visit",
            "type": "number",
            "placeholder": "请输入就诊年龄（岁）"
          },
          {
            "label": "身高（cm）",
            "name": "height",
            "type": "number",
            "placeholder": "请输入身高（cm）"
          },
          {
            "label": "体重（kg）",
            "name": "weight",
            "type": "number",
            "placeholder": "请输入体重（kg)"
          },
          {
            "label": "白斑首发年龄（岁）",
            "name": "onset_age",
            "type": "number",
            "placeholder": "请输入白斑首发年龄（岁）"
          },
          {
            "label": "白斑病程（月）",
            "name": "duration_months",
            "type": "number",
            "placeholder": "请输入白斑病程（月）"
          },
          {
            "label": "白癜风分型",
            "name": "vitiligo_type",
            "type": "select",
            "placeholder": "请选择白癜风分型",
            "option": [
              {
                "label": "",
                "id": 0,
                "value": ""
              },
              {
                "label": "节段型",
                "id": 1,
                "value": "节段型"
              },
              {
                "label": "非节段型",
                "id": 2,
                "value": "非节段型"
              },
              {
                "label": "混合型",
                "id": 3,
                "value": "混合型"
              },
              {
                "label": "未定类型",
                "id": 4,
                "value": "未定类型"
              }
            ]
          },
          {
            "label": "BSA评分（％）",
            "name": "bsa_score",
            "type": "number",
            "placeholder": "请输入BSA评分（％）"
          }
        ],
        皮损情况: [
          {
            "label": "白斑对称性",
            "name": "symmetry",
            "type": "select",
            "placeholder": "请选择白斑对称性",
            "multiple": true,
            "option": [
              {
                "label": "不对称",
                "id": 0,
                "value": "不对称"
              },
              {
                "label": "对称",
                "id": 1,
                "value": "对称"
              }
            ]
          },
          {
            "label": "白斑首次出现部位",
            "name": "first_location",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入白斑首次出现部位",
            "option": [
              {
                "label": "",
                "id": 0,
                "value": ""
              },
              {
                "label": "头皮",
                "id": 1,
                "value": "头皮"
              },
              {
                "label": "额部",
                "id": 2,
                "value": "额部"
              },
              {
                "label": "眶周",
                "id": 3,
                "value": "眶周"
              },
              {
                "label": "眉周",
                "id": 4,
                "value": "眉周"
              },
              {
                "label": "口周",
                "id": 5,
                "value": "口周"
              },
              {
                "label": "耳缘",
                "id": 6,
                "value": "耳缘"
              },
              {
                "label": "面部",
                "id": 7,
                "value": "面部"
              },
              {
                "label": "颈部",
                "id": 8,
                "value": "颈部"
              },
              {
                "label": "前胸",
                "id": 9,
                "value": "前胸"
              },
              {
                "label": "后背",
                "id": 10,
                "value": "后背"
              },
              {
                "label": "腹部",
                "id": 11,
                "value": "腹部"
              },
              {
                "label": "腰部",
                "id": 12,
                "value": "腰部"
              },
              {
                "label": "髂部",
                "id": 13,
                "value": "髂部"
              },
              {
                "label": "腹股沟区",
                "id": 14,
                "value": "腹股沟区"
              },
              {
                "label": "会阴区",
                "id": 15,
                "value": "会阴区"
              },
              {
                "label": "臀部",
                "id": 16,
                "value": "臀部"
              },
              {
                "label": "上肢",
                "id": 17,
                "value": "上肢"
              },
              {
                "label": "前臂",
                "id": 18,
                "value": "前臂"
              },
              {
                "label": "肘关节伸侧",
                "id": 19,
                "value": "肘关节伸侧"
              },
              {
                "label": "股部",
                "id": 20,
                "value": "股部"
              },
              {
                "label": "小腿",
                "id": 21,
                "value": "小腿"
              },
              {
                "label": "膝关节伸侧",
                "id": 22,
                "value": "膝关节伸侧"
              },
              {
                "label": "手背",
                "id": 23,
                "value": "手背"
              },
              {
                "label": "手掌",
                "id": 24,
                "value": "手掌"
              },
              {
                "label": "掌指关节伸侧",
                "id": 25,
                "value": "掌指关节伸侧"
              },
              {
                "label": "足背",
                "id": 26,
                "value": "足背"
              },
              {
                "label": "足底",
                "id": 27,
                "value": "足底"
              },
              {
                "label": "足跖关节伸侧",
                "id": 28,
                "value": "足跖关节伸侧"
              },
              {
                "label": "乳晕",
                "id": 29,
                "value": "乳晕"
              },
              {
                "label": "生殖器",
                "id": 30,
                "value": "生殖器"
              },
              {
                "label": "腋下",
                "id": 31,
                "value": "腋下"
              },
              {
                "label": "鼻周",
                "id": 32,
                "value": "鼻周"
              },
              {
                "label": "肛周",
                "id": 33,
                "value": "肛周"
              },
              {
                "label": "手腕",
                "id": 34,
                "value": "手腕"
              },
              {
                "label": "腘窝",
                "id": 35,
                "value": "腘窝"
              }
            ]
          },
          {
            "label": "现白斑部位",
            "name": "current_location",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入现白斑部位",
            "option": [
              {
                "label": "",
                "id": 0,
                "value": ""
              },
              {
                "label": "头皮",
                "id": 1,
                "value": "头皮"
              },
              {
                "label": "额部",
                "id": 2,
                "value": "额部"
              },
              {
                "label": "眶周",
                "id": 3,
                "value": "眶周"
              },
              {
                "label": "眉周",
                "id": 4,
                "value": "眉周"
              },
              {
                "label": "口周",
                "id": 5,
                "value": "口周"
              },
              {
                "label": "耳缘",
                "id": 6,
                "value": "耳缘"
              },
              {
                "label": "面部",
                "id": 7,
                "value": "面部"
              },
              {
                "label": "颈部",
                "id": 8,
                "value": "颈部"
              },
              {
                "label": "前胸",
                "id": 9,
                "value": "前胸"
              },
              {
                "label": "后背",
                "id": 10,
                "value": "后背"
              },
              {
                "label": "腹部",
                "id": 11,
                "value": "腹部"
              },
              {
                "label": "腰部",
                "id": 12,
                "value": "腰部"
              },
              {
                "label": "髂部",
                "id": 13,
                "value": "髂部"
              },
              {
                "label": "腹股沟区",
                "id": 14,
                "value": "腹股沟区"
              },
              {
                "label": "会阴区",
                "id": 15,
                "value": "会阴区"
              },
              {
                "label": "臀部",
                "id": 16,
                "value": "臀部"
              },
              {
                "label": "上肢",
                "id": 17,
                "value": "上肢"
              },
              {
                "label": "前臂",
                "id": 18,
                "value": "前臂"
              },
              {
                "label": "肘关节伸侧",
                "id": 19,
                "value": "肘关节伸侧"
              },
              {
                "label": "股部",
                "id": 20,
                "value": "股部"
              },
              {
                "label": "小腿",
                "id": 21,
                "value": "小腿"
              },
              {
                "label": "膝关节伸侧",
                "id": 22,
                "value": "膝关节伸侧"
              },
              {
                "label": "手背",
                "id": 23,
                "value": "手背"
              },
              {
                "label": "手掌",
                "id": 24,
                "value": "手掌"
              },
              {
                "label": "掌指关节伸侧",
                "id": 25,
                "value": "掌指关节伸侧"
              },
              {
                "label": "足背",
                "id": 26,
                "value": "足背"
              },
              {
                "label": "足底",
                "id": 27,
                "value": "足底"
              },
              {
                "label": "足跖关节伸侧",
                "id": 28,
                "value": "足跖关节伸侧"
              },
              {
                "label": "乳晕",
                "id": 29,
                "value": "乳晕"
              },
              {
                "label": "生殖器",
                "id": 30,
                "value": "生殖器"
              },
              {
                "label": "腋下",
                "id": 31,
                "value": "腋下"
              },
              {
                "label": "鼻周",
                "id": 32,
                "value": "鼻周"
              },
              {
                "label": "肛周",
                "id": 33,
                "value": "肛周"
              },
              {
                "label": "手腕",
                "id": 34,
                "value": "手腕"
              },
              {
                "label": "腘窝",
                "id": 35,
                "value": "腘窝"
              }
            ]
          },
          {
            "label": "白斑进展情况",
            "name": "progression_status",
            "type": "select",
            "placeholder": "请选择白斑进展情况",
            "option": [
              {
                "label": "白斑有复色",
                "id": 0,
                "value": "白斑有复色"
              },
              {
                "label": "白斑近1年稳定",
                "id": 1,
                "value": "白斑近1年稳定"
              },
              {
                "label": "白斑近1年进展",
                "id": 2,
                "value": "白斑近1年进展"
              },
              {
                "label": "白斑近6月进展",
                "id": 3,
                "value": "白斑近6月进展"
              },
              {
                "label": "白斑近3月进展",
                "id": 4,
                "value": "白斑近3月进展"
              },
              {
                "label": "白斑近6周进展",
                "id": 5,
                "value": "白斑近6周进展"
              }
            ]
          },
          {
            "label": "粘膜受累(阴囊不计入黏膜）",
            "name": "mucosal_involvement",
            "type": "select",
            "multiple": true,
            "placeholder": "请选择粘膜受累(阴囊不计入黏膜）",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "口唇",
                "id": 1,
                "value": "口唇"
              },
              {
                "label": "乳晕",
                "id": 2,
                "value": "乳晕"
              },
              {
                "label": "生殖器",
                "id": 3,
                "value": "生殖器"
              }
            ]
          },
          {
            "label": "白毛白发",
            "name": "leukotrichia",
            "type": "select",
            "multiple": true,
            "placeholder": "请选择白毛白发",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "头发变白",
                "id": 1,
                "value": "头发变白"
              },
              {
                "label": "眉毛变白",
                "id": 2,
                "value": "眉毛变白"
              },
              {
                "label": "睫毛变白",
                "id": 3,
                "value": "睫毛变白"
              },
              {
                "label": "胡须变白",
                "id": 4,
                "value": "胡须变白"
              },
              {
                "label": "腋毛变白",
                "id": 5,
                "value": "腋毛变白"
              },
              {
                "label": "阴毛变白",
                "id": 6,
                "value": "阴毛变白"
              },
              {
                "label": "汗毛变白",
                "id": 7,
                "value": "汗毛变白"
              },
              {
                "label": "鼻毛变白",
                "id": 8,
                "value": "鼻毛变白"
              }
            ]
          },
          {
            "label": "白斑颜色",
            "name": "lesion_color",
            "type": "select",
            "placeholder": "请输入白斑颜色",
            "option": [
              {
                "label": "",
                "id": 0,
                "value": ""
              },
              {
                "label": "瓷白色",
                "id": 1,
                "value": "瓷白色"
              },
              {
                "label": "乳白色",
                "id": 2,
                "value": "乳白色"
              },
              {
                "label": "灰白色",
                "id": 3,
                "value": "灰白色"
              },
              {
                "label": "其他",
                "id": 4,
                "value": "其他"
              }
            ]
          },
          {
            "label": "白斑分布特征",
            "name": "distribution_pattern",
            "type": "select",
            "placeholder": "请输入白斑分布特征",
            "option": [
              {
                "label": "",
                "id": 0,
                "value": ""
              },
              {
                "label": "多发性点状白斑",
                "id": 1,
                "value": "多发性点状白斑"
              },
              {
                "label": "椭圆形白斑",
                "id": 2,
                "value": "椭圆形白斑"
              },
              {
                "label": "两者都有",
                "id": 3,
                "value": "两者都有"
              },
              {
                "label": "其他",
                "id": 4,
                "value": "其他"
              }
            ]
          },
          {
            "label": "白斑稳定/活动特征",
            "name": "stability_features",
            "type": "select",
            "placeholder": "请输入白斑稳定/活动特征",
            "option": [
              {
                "label": "白斑区复色",
                "id": 0,
                "value": "白斑区复色"
              },
              {
                "label": "白斑边界清楚",
                "id": 1,
                "value": "白斑边界清楚"
              },
              {
                "label": "白斑边界模糊",
                "id": 2,
                "value": "白斑边界模糊"
              },
              {
                "label": "碎纸屑样白斑",
                "id": 3,
                "value": "碎纸屑样白斑"
              },
              {
                "label": "三色征",
                "id": 4,
                "value": "三色征"
              }
            ]
          },
          {
            "label": "备注-边界",
            "name": "boundary",
            "type": "select",
            "placeholder": "请输入备注-边界",
            "option": [
              {
                "label": "",
                "id": 0,
                "value": ""
              },
              {
                "label": "部分边界清楚",
                "id": 1,
                "value": "部分边界清楚"
              },
              {
                "label": "部分边界模糊",
                "id": 2,
                "value": "部分边界模糊"
              }
            ]
          },
          {
            "label": "白斑症状及其他伴随现象",
            "name": "symptoms",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入白斑症状及其他伴随现象",
            "option": [
              {
                "label": "无症状",
                "id": 0,
                "value": "无症状"
              },
              {
                "label": "瘙痒",
                "id": 1,
                "value": "瘙痒"
              },
              {
                "label": "灼热",
                "id": 2,
                "value": "灼热"
              },
              {
                "label": "白斑周围发红",
                "id": 3,
                "value": "白斑周围发红"
              },
              {
                "label": "晕痣",
                "id": 4,
                "value": "晕痣"
              },
              {
                "label": "有同形反应",
                "id": 5,
                "value": "有同形反应"
              },
              {
                "label": "其他",
                "id": 6,
                "value": "其他"
              }
            ]
          },
          {
            "label": "wood灯下白斑颜色",
            "name": "wood_lamp_color",
            "type": "select",
            "placeholder": "请输入wood灯下白斑颜色",
            "option": [
              {
                "label": "",
                "id": 0,
                "value": ""
              },
              {
                "label": "亮蓝色",
                "id": 1,
                "value": "亮蓝色"
              },
              {
                "label": "蓝白色",
                "id": 2,
                "value": "蓝白色"
              },
              {
                "label": "深棕色和黑色",
                "id": 3,
                "value": "深棕色和黑色"
              },
              {
                "label": "其他",
                "id": 4,
                "value": "其他"
              }
            ]
          },
          {
            "label": "wood灯下白斑面积",
            "name": "wood_lamp_area",
            "type": "select",
            "placeholder": "请输入wood灯下白斑面积",
            "option": [
              {
                "label": "无法准确评估",
                "id": 0,
                "value": "无法准确评估"
              },
              {
                "label": "大于肉眼白斑",
                "id": 1,
                "value": "大于肉眼白斑"
              },
              {
                "label": "等于肉眼白斑",
                "id": 2,
                "value": "等于肉眼白斑"
              },
              {
                "label": "小于肉眼白斑",
                "id": 3,
                "value": "小于肉眼白斑"
              }
            ]
          },
          {
            "label": "备注1",
            "name": "remark1",
            "type": "input",
            "placeholder": "请输入备注1",
            // "option": [
            //   {
            //     "label": "",
            //     "id": 0,
            //     "value": ""
            //   }
            // ]
          }
        ],
        病因病机: [
          {
            "label": "白斑发病季节",
            "name": "onset_season",
            "type": "select",
            "multiple": true,
            "placeholder": "请选择白斑发病季节",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "春天",
                "id": 1,
                "value": "春天"
              },
              {
                "label": "夏天",
                "id": 2,
                "value": "夏天"
              },
              {
                "label": "秋天",
                "id": 3,
                "value": "秋天"
              },
              {
                "label": "冬天",
                "id": 4,
                "value": "冬天"
              }
            ]
          },
          {
            "label": "白斑发病诱因",
            "name": "onset_trigger",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入白斑发病诱因",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "农药",
                "id": 1,
                "value": "农药"
              },
              {
                "label": "化工产品",
                "id": 2,
                "value": "化工产品"
              },
              {
                "label": "冻伤",
                "id": 3,
                "value": "冻伤"
              },
              {
                "label": "烫伤",
                "id": 4,
                "value": "烫伤"
              },
              {
                "label": "外伤",
                "id": 5,
                "value": "外伤"
              },
              {
                "label": "劳累",
                "id": 6,
                "value": "劳累"
              },
              {
                "label": "焦虑",
                "id": 7,
                "value": "焦虑"
              },
              {
                "label": "压力大",
                "id": 8,
                "value": "压力大"
              },
              {
                "label": "悲伤",
                "id": 9,
                "value": "悲伤"
              },
              {
                "label": "日光暴晒",
                "id": 10,
                "value": "日光暴晒"
              },
              {
                "label": "疫苗接种",
                "id": 11,
                "value": "疫苗接种"
              },
              {
                "label": "特殊药物",
                "id": 12,
                "value": "特殊药物"
              },
              {
                "label": "妊娠",
                "id": 13,
                "value": "妊娠"
              },
              {
                "label": "产后",
                "id": 14,
                "value": "产后"
              },
              {
                "label": "感染新冠",
                "id": 15,
                "value": "感染新冠"
              },
              {
                "label": "感染乙肝",
                "id": 16,
                "value": "感染乙肝"
              },
              {
                "label": "感染丙肝",
                "id": 17,
                "value": "感染丙肝"
              },
              {
                "label": "感染艾滋",
                "id": 18,
                "value": "感染艾滋"
              },
              {
                "label": "流感",
                "id": 19,
                "value": "流感"
              }
            ]
          },
          {
            "label": "白斑加重诱因",
            "name": "aggravation_trigger",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入白斑加重诱因",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "农药",
                "id": 1,
                "value": "农药"
              },
              {
                "label": "化工产品",
                "id": 2,
                "value": "化工产品"
              },
              {
                "label": "冻伤",
                "id": 3,
                "value": "冻伤"
              },
              {
                "label": "烫伤",
                "id": 4,
                "value": "烫伤"
              },
              {
                "label": "外伤",
                "id": 5,
                "value": "外伤"
              },
              {
                "label": "劳累",
                "id": 6,
                "value": "劳累"
              },
              {
                "label": "焦虑",
                "id": 7,
                "value": "焦虑"
              },
              {
                "label": "压力大",
                "id": 8,
                "value": "压力大"
              },
              {
                "label": "悲伤",
                "id": 9,
                "value": "悲伤"
              },
              {
                "label": "日光暴晒",
                "id": 10,
                "value": "日光暴晒"
              },
              {
                "label": "疫苗接种",
                "id": 11,
                "value": "疫苗接种"
              },
              {
                "label": "特殊药物",
                "id": 12,
                "value": "特殊药物"
              },
              {
                "label": "妊娠",
                "id": 13,
                "value": "妊娠"
              },
              {
                "label": "产后",
                "id": 14,
                "value": "产后"
              },
              {
                "label": "感染新冠",
                "id": 15,
                "value": "感染新冠"
              },
              {
                "label": "感染乙肝",
                "id": 16,
                "value": "感染乙肝"
              },
              {
                "label": "感染丙肝",
                "id": 17,
                "value": "感染丙肝"
              },
              {
                "label": "感染艾滋",
                "id": 18,
                "value": "感染艾滋"
              },
              {
                "label": "流感",
                "id": 19,
                "value": "流感"
              }
            ]
          },
          {
            "label": "白斑复发诱因",
            "name": "recurrence_trigger",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入白斑复发诱因",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "农药",
                "id": 1,
                "value": "农药"
              },
              {
                "label": "化工产品",
                "id": 2,
                "value": "化工产品"
              },
              {
                "label": "冻伤",
                "id": 3,
                "value": "冻伤"
              },
              {
                "label": "烫伤",
                "id": 4,
                "value": "烫伤"
              },
              {
                "label": "外伤",
                "id": 5,
                "value": "外伤"
              },
              {
                "label": "劳累",
                "id": 6,
                "value": "劳累"
              },
              {
                "label": "焦虑",
                "id": 7,
                "value": "焦虑"
              },
              {
                "label": "压力大",
                "id": 8,
                "value": "压力大"
              },
              {
                "label": "悲伤",
                "id": 9,
                "value": "悲伤"
              },
              {
                "label": "日光暴晒",
                "id": 10,
                "value": "日光暴晒"
              },
              {
                "label": "疫苗接种",
                "id": 11,
                "value": "疫苗接种"
              },
              {
                "label": "特殊药物",
                "id": 12,
                "value": "特殊药物"
              },
              {
                "label": "妊娠",
                "id": 13,
                "value": "妊娠"
              },
              {
                "label": "产后",
                "id": 14,
                "value": "产后"
              },
              {
                "label": "感染新冠",
                "id": 15,
                "value": "感染新冠"
              },
              {
                "label": "感染乙肝",
                "id": 16,
                "value": "感染乙肝"
              },
              {
                "label": "感染丙肝",
                "id": 17,
                "value": "感染丙肝"
              },
              {
                "label": "感染艾滋",
                "id": 18,
                "value": "感染艾滋"
              },
              {
                "label": "流感",
                "id": 19,
                "value": "流感"
              }
            ]
          },
          {
            "label": "伴发疾病",
            "name": "comorbidities",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入伴发疾病",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "斑秃",
                "id": 1,
                "value": "斑秃"
              },
              {
                "label": "特应性皮炎",
                "id": 2,
                "value": "特应性皮炎"
              },
              {
                "label": "银屑病",
                "id": 3,
                "value": "银屑病"
              },
              {
                "label": "红斑狼疮",
                "id": 4,
                "value": "红斑狼疮"
              },
              {
                "label": "甲亢",
                "id": 5,
                "value": "甲亢"
              },
              {
                "label": "甲减",
                "id": 6,
                "value": "甲减"
              },
              {
                "label": "桥本氏甲状腺炎",
                "id": 7,
                "value": "桥本氏甲状腺炎"
              },
              {
                "label": "甲功异常",
                "id": 8,
                "value": "甲功异常"
              },
              {
                "label": "1型糖尿病",
                "id": 9,
                "value": "1型糖尿病"
              },
              {
                "label": "2型糖尿病",
                "id": 10,
                "value": "2型糖尿病"
              },
              {
                "label": "乙肝",
                "id": 11,
                "value": "乙肝"
              },
              {
                "label": "丙肝",
                "id": 12,
                "value": "丙肝"
              },
              {
                "label": "艾滋病",
                "id": 13,
                "value": "艾滋病"
              },
              {
                "label": "炎症性肠病",
                "id": 14,
                "value": "炎症性肠病"
              },
              {
                "label": "类风湿性关节炎",
                "id": 15,
                "value": "类风湿性关节炎"
              },
              {
                "label": "强直性脊柱炎",
                "id": 16,
                "value": "强直性脊柱炎"
              },
              {
                "label": "其他",
                "id": 17,
                "value": "其他"
              }
            ]
          },
          {
            "label": "白癜风家族史",
            "name": "family_history",
            "type": "select",
            "placeholder": "请选择白癜风家族史",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "家族中1人",
                "id": 1,
                "value": "家族中1人"
              },
              {
                "label": "家族中2人",
                "id": 2,
                "value": "家族中2人"
              },
              {
                "label": "家族中3人",
                "id": 3,
                "value": "家族中3人"
              },
              {
                "label": "家族中3人以上",
                "id": 4,
                "value": "家族中3人以上"
              }
            ]
          },
          {
            "label": "阳性家族史(亲属关系)",
            "name": "family_history_notes",
            "type": "input",
            "placeholder": "请输入阳性家族史备注-亲属关系"
          },
          {
            "label": "自身免疫性疾病家族史",
            "name": "autoimmune_family_history",
            "type": "select",
            "placeholder": "请选择自身免疫性疾病家族史",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "有",
                "id": 1,
                "value": "有"
              }
            ]
          },
          {
            "label": "阳性自免病家族史(疾病和关系)",
            "name": "autoimmune_family_notes",
            "type": "input",
            "placeholder": "请输入阳性自免病家族史备注-疾病和关系"
            
          },
          {
            "label": "新冠疫苗接种史",
            "name": "covid_vaccination",
            "type": "select",
            "placeholder": "请选择新冠疫苗接种史",
            "option": [
              {
                "label": "未接种",
                "id": 0,
                "value": "未接种"
              },
              {
                "label": "已接种",
                "id": 1,
                "value": "已接种"
              }
            ]
          },
          {
            "label": "新冠疫苗感染史",
            "name": "covid_infection",
            "type": "select",
            "placeholder": "请选择新冠疫苗感染史",
            "option": [
              {
                "label": "未感染",
                "id": 0,
                "value": "未感染"
              },
              {
                "label": "已感染,",
                "id": 1,
                "value": "已感染,"
              }
            ]
          },
          {
            "label": "备注2",
            "name": "remark2",
            "type": "input",
            "placeholder": "请输入备注2"      
          }
        ],
        治疗情况: [
          {
            "label": "白癜风治疗",
            "name": "treatment_history",
            "type": "select",
            "placeholder": "请输入白癜风治疗",
            "option": [
              {
                "label": "未治疗",
                "id": 0,
                "value": "未治疗"
              },
              {
                "label": "已治疗",
                "id": 1,
                "value": "已治疗"
              }
            ]
          },
          {
            "label": "白癜风系统用药",
            "name": "systemic_medication",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入白癜风系统用药",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "托法替布",
                "id": 1,
                "value": "托法替布"
              },
              {
                "label": "巴瑞替尼",
                "id": 2,
                "value": "巴瑞替尼"
              },
              {
                "label": "得宝松肌注",
                "id": 3,
                "value": "得宝松肌注"
              },
              {
                "label": "甲泼尼龙片",
                "id": 4,
                "value": "甲泼尼龙片"
              },
              {
                "label": "泼尼松片",
                "id": 5,
                "value": "泼尼松片"
              },
              {
                "label": "复方甘草酸苷片",
                "id": 6,
                "value": "复方甘草酸苷片"
              },
              {
                "label": "环孢素",
                "id": 7,
                "value": "环孢素"
              },
              {
                "label": "甲氨蝶呤",
                "id": 8,
                "value": "甲氨蝶呤"
              },
              {
                "label": "中药",
                "id": 9,
                "value": "中药"
              },
              {
                "label": "胸腺肽",
                "id": 10,
                "value": "胸腺肽"
              },
              {
                "label": "补钙",
                "id": 11,
                "value": "补钙"
              },
              {
                "label": "白芍总苷",
                "id": 12,
                "value": "白芍总苷"
              },
              {
                "label": "白灵片",
                "id": 13,
                "value": "白灵片"
              },
              {
                "label": "乌帕替尼",
                "id": 14,
                "value": "乌帕替尼"
              },
              {
                "label": "阿布昔替尼",
                "id": 15,
                "value": "阿布昔替尼"
              },
              {
                "label": "利特昔替尼",
                "id": 16,
                "value": "利特昔替尼"
              },
              {
                "label": "他克莫司（口服）",
                "id": 17,
                "value": "他克莫司（口服）"
              }
            ]
          },
          {
            "label": "白癜风用药2",
            "name": "topical_medication",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入白癜风用药2",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "卤米松/丙酸氟替卡松",
                "id": 1,
                "value": "卤米松/丙酸氟替卡松"
              },
              {
                "label": "他克莫司",
                "id": 2,
                "value": "他克莫司"
              },
              {
                "label": "复方卡力孜然酊",
                "id": 3,
                "value": "复方卡力孜然酊"
              },
              {
                "label": "克立硼罗软膏",
                "id": 4,
                "value": "克立硼罗软膏"
              },
              {
                "label": "芦可替尼乳膏",
                "id": 5,
                "value": "芦可替尼乳膏"
              }
            ]
          },
          {
            "label": "光疗方式",
            "name": "phototherapy_method",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入光疗方式",
            "option": [
              {
                "label": "未做",
                "id": 0,
                "value": "未做"
              },
              {
                "label": "家庭",
                "id": 1,
                "value": "家庭"
              },
              {
                "label": "医院",
                "id": 2,
                "value": "医院"
              },
              {
                "label": "不详",
                "id": 3,
                "value": "不详"
              }
            ]
          },
          {
            "label": "光疗类型",
            "name": "phototherapy_type",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入光疗类型",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "NB-UVB",
                "id": 1,
                "value": "NB-UVB"
              },
              {
                "label": "308nm准分子光（希兰）",
                "id": 2,
                "value": "308nm准分子光（希兰）"
              },
              {
                "label": "308nm准分子激光",
                "id": 3,
                "value": "308nm准分子激光"
              },
              {
                "label": "308nmLED",
                "id": 4,
                "value": "308nmLED"
              },
              {
                "label": "激光+得宝松导入",
                "id": 5,
                "value": "激光+得宝松导入"
              },
              {
                "label": "激光+5-Fu导入",
                "id": 6,
                "value": "激光+5-Fu导入"
              },
              {
                "label": "308nm光疗",
                "id": 7,
                "value": "308nm光疗"
              }
            ]
          },
          {
            "label": "外科手术",
            "name": "surgical_treatment",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入外科手术",
            "option": [
              {
                "label": "未做",
                "id": 0,
                "value": "未做"
              },
              {
                "label": "表皮负压吸疱移植",
                "id": 1,
                "value": "表皮负压吸疱移植"
              },
              {
                "label": "毛囊移植",
                "id": 2,
                "value": "毛囊移植"
              },
              {
                "label": "晕痣切除",
                "id": 3,
                "value": "晕痣切除"
              }
            ]
          },
          {
            "label": "其他治疗",
            "name": "other_treatments",
            "type": "select",
            "multiple": true,
            "placeholder": "请输入其他治疗",
            "option": [
              {
                "label": "无",
                "id": 0,
                "value": "无"
              },
              {
                "label": "火针",
                "id": 1,
                "value": "火针"
              },
              {
                "label": "RPR治疗",
                "id": 2,
                "value": "RPR治疗"
              },
              {
                "label": "白癜风洗剂",
                "id": 3,
                "value": "白癜风洗剂"
              }
            ]
          },
          {
            "label": "备注3",
            "name": "remark3",
            "type": "input",
            "placeholder": "请输入备注3"
            
          }
        ]
      }

      return formData;
    }

  },
  async created() {
    await this.getKnowledgeDic();
    await this.queryMyTemplate();
    this.inputOptions = this.genInputOptions();
    this.keywordMap =this.genKeywordMap();
    this.formData = this.genForms();
    console.log("vitiligoBasicInfoDialog created, formData.keys:", Object.keys(this.formData));
    console.log("vitiligoBasicInfoDialog created, inputOptions.keys:", Object.keys(this.inputOptions));
  }

};
</script>
<style lang="less">
.vitiligoBasicInfoDialog {
  .el-dialog__title {
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
  .el-dialog__body {
    padding: 0 20px 30px;
  }
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-input__inner {
    border-radius: 8px;
    height: 46px;
    color: #6b6b6b;
    font-size: 18px;
  }
  .el-input__prefix {
    left: 250px;
    i {
      font-size: 35px !important;
      color: #797979;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
  .el-input__icon {
    line-height: 46px;
  }
  .el-input__suffix-inner {
    i {
      font-size: 30px !important;
      color: #797979 !important;
    }
  }
  .el-input__suffix {
    right: 10px !important;
  }
  .el-button--primary {
    border-radius: 6px;
  }
  .dialog-pic .el-dialog__header{
    padding-bottom: 28px;
  }
  .el-dialog__wrapper{
    display: block;
  }
}
</style>
<style lang="less" scoped>
.vitiligoBasicInfoDialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;  
  .popTitleDialog {
    font-size: 20px;
    font-weight: 600;
    color: black;
    margin-bottom: 15px;
    margin-top: 15px;
    text-indent: 12px;
  }
  .dialog {
    // min-width: 1205px;   
    // background: #e9c4c4;
    display: flex;
    align-items: center;    
    .navBorder {
      width: 100%;
      height: 2px;
      background: #4da3c0;
    }
  }
  .main {
    width: 100%;
    // min-width: 1200px;
    // background: #c8ea85;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
    
    overflow-y: auto;
    .left {
      width: 100%;
      // min-width: 1200px;
      height: 100%;
      // background: rgb(136, 188, 248);
      display: inline-block;
      
      .popInput {
        width: 280px;
        border: 1px solid #c0c0c0 !important;
        border-radius: 8px;
        height: 48px;
        box-sizing: border-box;
      }
      .popInputSingle {
        width: 619px !important;
      }
      
      
    }
    // .right {
    //   display: inline-block;
    //   .rightItem {
    //     .rightItemContent {
    //       position: relative;
    //       border: 10px solid white;
    //       width: 475px;
    //       height: 333px;
    //       border-radius: 20px;
    //       display: flex;
    //       justify-content: center;
    //       align-items: center;
    //       box-sizing: border-box;
    //       .images-wrap{
    //         position: absolute;
    //         left: 0;
    //         top: 0;
    //         width: 100%;
    //         height: 100%;
    //         box-sizing: border-box;
    //         background-color: rgb(235,235,235);
    //         padding: 10px 5px 10px 20px;
    //         overflow-y: auto;
    //         .images-list{
    //           display: flex;
    //           flex-wrap: wrap;
    //           width: 100%;
    //           .image-item{
    //             position: relative;
    //             width: 135px;
    //             height: 135px;
    //             margin-right: 4px;
    //             margin-bottom: 8px;
    //             background-repeat: no-repeat;
    //             background-size: cover;
    //             background-position: center center;
    //           }
    //           .image-item:nth-child(3n){
    //             margin-right: 0;
    //           }
    //         }
    //         .add-btn{
    //           display: flex;
    //           justify-content: center;
    //           align-items: center;
    //           color: #fff;
    //           width: 414px;
    //           height: 60px;
    //           border: 3px dashed #fff;
    //           box-sizing: border-box;
    //           font-size: 22px;
    //           cursor: pointer;
    //         }
    //       }
    //       .rightItemIcon {
    //         font-size: 165px;
    //         color: white;
    //       }
    //     }
    //   }
    //   .inpatInput,
    //   .outpatInput {
    //     display: none;
    //   }
    // }
  }
}
.icon-wrapper{
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 3px;
  margin-left: 3px;
  .menu-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 33px;
    height: 30px;
    background-color: #ebebeb;
    border-radius: 5px;
    background-color: rgba(240, 240, 240, 0.9);
    cursor: pointer;
    user-select: none;
    .screen-icon {
      color: #1296db;
      font-size: 22px;
    }
    .delete-icon {
      width: 28px;
      height: 26px;
    }
    .love-icon {
      width: 28px;
      height: 28px;
    }
    .ai-text{
      color: rgb(64, 165, 219);
      font-size: 24px;
    }
  }
  .menu-btn + .menu-btn {
    margin-left: 2px;
  }
  .menu-btn:hover{
    background-color: #ccc;
  }
}

.dialog-footer{
  display: flex;
  justify-content: center;
  align-items: center;
}
.leftItemSubmit {
  width: 280px;
  height: 42px;
  // margin-top: 34px;
}
</style>
